import {
  List,
  Datagrid,
  TextField,
  EditButton,
  // DeleteButton,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  TopToolbar,
  ListButton,
} from 'react-admin';

interface ServiceProviderProps {
  id: number;
  guid: string;
  service_name: string;
  service_description: string;
  sso_settings_type: string;
}

const postFilters = [<TextInput label="Search" source="terms" alwaysOn />];

export const ServiceProviderList = (props: ServiceProviderProps) => {
  return (
    <List {...props} filters={postFilters}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="service_name" />
        <TextField source="service_description" />
        <TextField source="sso_settings_type" />
        <EditButton />
        {/* <DeleteButton /> */}
      </Datagrid>
    </List>
  );
};

const EditActions = () => (
  <TopToolbar>
    <ListButton label="Retour à la liste" />
  </TopToolbar>
);

export const ServiceProviderEdit = () => {
  return (
    <Edit actions={<EditActions />}>
      <SimpleForm>
        <TextInput fullWidth source="id" disabled />
        <TextInput fullWidth source="service_name" required />
        <TextInput fullWidth source="service_description" />
        <TextInput fullWidth source="sso_settings_type" required />
      </SimpleForm>
    </Edit>
  );
};

export const ServiceProviderCreate = () => (
  <Create actions={<EditActions />}>
    <SimpleForm>
      <TextInput fullWidth source="service_name" required />
      <TextInput fullWidth source="service_description" />
      <TextInput fullWidth source="sso_settings_type" />
    </SimpleForm>
  </Create>
);
